
import { useEffect, useState } from 'react';
import ButtonFrame from '../ButtonFrame';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreator } from '../../redux';
import { FB_APP_ID, FB_APP_VERSION } from '../../action/constant';
import ToastMessage from '../ToastMessage';

const SignInModal = ({ closeSignIn, openSignUp, onSubmit  }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [passwordVisible, setPasswordVisible] = useState(false);

    const [msgAlert, setMsgAlert] = useState({
      active: false,
      message: "",
      status: "warning"
    });

    const dispatch = useDispatch();
    // const { login, loginSocial } = bindActionCreators(actionCreator, dispatch);
    const { login } = bindActionCreators(actionCreator, dispatch);
    
    const handleInputChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    }

    useEffect(() => {
      (() => {
        window.fbAsyncInit = function() {
          window.FB.init({
            appId      : FB_APP_ID,
            cookie     : true,
            xfbml      : true,
            version    : FB_APP_VERSION
          });
            
          window.FB.AppEvents.logPageView();   
            
        };
      
        (function(d, s, id){
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {return;}
          js = d.createElement(s); js.id = id;
          js.src = "https://connect.facebook.net/en_US/sdk.js";
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
      })();
    });

    const submitSignin = async () => {

        if (!formData.email.includes('@')) {
            setMsgAlert({
              active: true,
              message: 'Enter a valid email address',
              status: "warning"
            });
            return;
        }

        if (formData.password.length === 0) {
            setMsgAlert({
              active: true,
              message: 'Password is required',
              status: "warning"
            });
            return;
        }
      
        setLoading(true);

        let result = await login(formData);

        if (result.status) {
            setLoading(false);
            onSubmit();
        }else {
            setMsgAlert({
              active: true,
              message: result.message,
              status: "error"
            });
            setLoading(false);
        }
    }

    // const login_social = async (resp) => {
    //   if (!resp.authResponse) {
    //     setLoading(false);
    //     return;
    //   }

    //   let result = await loginSocial({
    //     accessToken: resp.authResponse.accessToken
    //   });

    //   if (result.status) {
    //     setLoading(false);
    //     window.location.reload();
    //   }else {
    //     await window.FB.logout();
    //     setMsgAlert({
    //       active: true,
    //       message: result.message,
    //       status: "error"
    //     });
    //     setLoading(false);
    //   }
    // }

    // const statusChangeCallback = async (response) => {
    //   if (response.status !== 'connected') {
    //     setLoading(true);
    //     await window.FB.login((resp) => {
    //       login_social(resp);
    //     });
    //   }else {
    //     await window.FB.logout();
    //   }
    // }

    // const facebookSignIn = async () => {
    //   await window.FB.getLoginStatus(async (response) => {
    //       await statusChangeCallback(response);
    //   });
    // }

    return (
      <>
        <div className="modal-overlay" onClick={() => closeSignIn()}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src="/assets/close.png" alt="Close Icon" className='signup-close-icon' onClick={() => closeSignIn()}/>
            <div className='modal-main-container'>
              <h2 className="modal-title">Welcome back</h2>
              <div className='signup-modal-container'>
                <div className='signup-input-container'>
                  <div className='modal-input-container'>
                    <div className='input-form-box'>
                      <div className="floating-label-container">
                        <input
                          type="email"
                          id="emailAddress"
                          name="email"
                          placeholder=" "
                          className="floating-input"
                          value={formData.email}
                          onChange={(e) => handleInputChange(e)}
                          required
                        />
                        <label htmlFor="emailAddress" className="floating-label">
                          Email Address
                        </label>
                      </div>
                      <div className="password-input-container">
                        <div className="floating-label-container">
                          <input
                            type={passwordVisible ? "text" : "password"}
                            id="password"
                            placeholder=" "
                            name="password"
                            className="floating-input"
                            value={formData.password}
                            onChange={(e) => handleInputChange(e)}
                            required
                          />
                          <label htmlFor="password" className="floating-label">
                            Password
                          </label>
                        </div>
                        <span
                          className="toggle-password-visibility"
                          onClick={() => setPasswordVisible(!passwordVisible)}
                        >
                          {passwordVisible ? (
                            <img src="/assets/mdi_eye-outline.png" alt="Hide Password" className="password-eye-icon"/>
                          ) : (
                            <img src="/assets/mdi_hide-outline.png" alt="Show Password" className="password-eye-icon"/>
                          )}
                        </span>
                      </div>
                    </div>
                    <ButtonFrame handleClick={submitSignin} loading={loading} btnText={"Sign In"} classNameStyle={"sign-in-btn"} />
                  </div>
                  <div className="signup-link" onClick={openSignUp}>
                    <p className='signup-link-span'>Don't have an account? <span className="signup-link-navLink">Sign Up</span></p>
                  </div>
                </div>

                {/* <div className="or-separator">
                  <div className='signup-divider'></div>
                  <p>OR</p>
                  <div className='signup-divider'></div>
                </div>

                <div onClick={() => facebookSignIn()} className="social-btn">
                  <img src="/assets/icons8-facebook.svg" alt="Facebook icon" className="social-icon" />
                  <span className="social-link-span">Continue with Facebook</span>
                </div> */}
              </div>

            </div>
          </div>
        </div>
        {msgAlert.active && <ToastMessage toastTitle={"Login"} toastMessage={msgAlert.message} toastType={msgAlert.status} closeOut={() => setMsgAlert({...msgAlert, active:false})} />}
      </>
    )
}

export default SignInModal;